import { render, staticRenderFns } from "./ImpersonateLogin.vue?vue&type=template&id=cfb94ea8&"
import script from "./ImpersonateLogin.vue?vue&type=script&lang=js&"
export * from "./ImpersonateLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports